var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[`cv-tag ${_vm.carbonPrefix}--tag ${_vm.carbonPrefix}--skeleton`, { [`${_vm.carbonPrefix}--tag--${_vm.size}`]: _vm.size }]})
}
var staticRenderFns = []

export { render, staticRenderFns }